"use client";

import { Button } from "@/components/Button";
import { useRedirectToPaymentPage } from "@/hooks/payment";
import { useSession } from "next-auth/react";
import { useRouter } from "next/navigation";
import Link from "next/link";

export default function Hero() {
  const { redirectToPaymentPage } = useRedirectToPaymentPage();
  const { data, status } = useSession();
  const router = useRouter();

  const handleEnroll = () => {
    if (status === "authenticated" && data?.user?.hasPaid) {
      router.push("/dashboard/user");
      return;
    }
    redirectToPaymentPage();
  };

  return (
    <div className="bg-gradient-to-b from-[#081329] to-[#1b428e]">
      <section className="px-fluid-container grid-cols-5 items-center justify-between text-white md:min-h-[83lvh] lg:grid">
        <header className="col-span-3 mb-10 w-full pt-10 sm:pt-16 lg:mb-0 lg:pt-0">
          <h1 className="text-hero mb-2 leading-[1.125] font-[900] text-[#FF9053] uppercase">
            GRE Universe <div>course</div>
          </h1>
          <p className="text-lg-0 mb-3.5 max-w-[95%] leading-tight font-[600] text-balance">
            Your Entire GRE Universe In One Course — Everything You Need,
            Nothing You Don&apos;t.
          </p>
          <p className="text-fluid-base-0 text-base-0 mb-2.5 block font-[400]">
            At ₹5,990/- for 3 months.
          </p>
          <div className="text-sm-0 w-[40%] max-w-64">
            <Button
              onClick={handleEnroll}
              label={
                status === "authenticated" && data?.user?.hasPaid
                  ? "Go to Dashboard"
                  : "Enroll now"
              }
            />
          </div>
          <Link
            className="text-sm-0 pretty mt-5 inline-block italic hover:underline"
            href="/#private-personalised-tutoring"
          >
            Need personal tutoring? Learn about one-to-one
          </Link>
        </header>
        <div className="col-span-2 pb-16 text-center lg:mb-0 lg:pb-0">
          <div className="px-sm mx-auto w-[85%] max-w-[500px] sm:w-full">
            <div className="relative mb-5 flex aspect-square items-center justify-center rounded-full">
              {/* Center profile image */}
              <div className="flex h-[70%] w-[70%] items-start justify-center overflow-hidden rounded-full">
                <div className="bg-white/55">
                  <img
                    fetchPriority="high"
                    className="w-full -scale-x-100"
                    src="/images/prof-punit.webp"
                    alt="Prof. Punit"
                  />
                </div>
              </div>

              {/* Orbiting flags container */}
              <div className="flag-orbit absolute inset-0 flex h-full w-full items-center justify-center">
                {/* Canada flag - bottom */}
                <img
                  fetchPriority="high"
                  className="absolute bottom-[10%] left-[26%] w-[7%]"
                  src="/images/canada.webp"
                  alt=""
                />
                {/* US flag - left */}
                <img
                  fetchPriority="high"
                  className="absolute top-[28%] left-[8%] w-[9%]"
                  src="/images/us.webp"
                  alt=""
                />
                {/* UK flag - top */}
                <img
                  fetchPriority="high"
                  className="absolute top-0 right-[30%] w-[8%]"
                  src="/images/uk.webp"
                  alt=""
                />
                {/* Australia flag - right */}
                <img
                  fetchPriority="high"
                  className="absolute top-[25%] right-[1%] w-[8%]"
                  src="/images/australia.webp"
                  alt=""
                />
              </div>

              {/* Orbiting border circles */}
              <div className="absolute inset-0 flex h-full w-full items-center justify-center blur-[0.7px] sm:blur-[1.5px]">
                <div className="insert-0 absolute h-full w-full rounded-full border-1 border-dashed border-white/40 sm:border-3"></div>
                <div className="h-[85%] w-[85%] rounded-full border-1 border-white/40 sm:border-4"></div>
              </div>
            </div>
          </div>
          <a
            href="#instructor"
            className="text-sm-0 mt-3 inline-block rounded-full bg-white px-5 py-2 font-[600] text-[#505866]"
          >
            Punit Mishra: 337/340
          </a>
        </div>
      </section>
    </div>
  );
}
